// mui
import { Container } from '@mui/material';

// components
import Page from '../components/Page';
import Footer from '../ui-component/Footer';

// ----------------------------------------------------------------------

export default function CancellationPolicy() {

  return (
    <Page title="Cancellation Policy">
      <Container maxWidth="md" sx={{ py: 6 }}>
        <div id="__next">
          <div className="docs">
            <div>
              <h1>
                <strong>voicetyping.xyz's CANCELLATION POLICY — AryaStack Technologies</strong>
              </h1>
              <ul>
                <li>Effective: APRIL 19, 2025.</li>
              </ul>
              <h1>
                <strong>SERVICE PURCHASES ARE NON-REFUNDABLE</strong>
              </h1>
              <p>
                Please read this policy carefully before making any purchase on voicetyping.xyz.
              </p>
              <p>
                At voicetyping.xyz, operated by AryaStack Technologies, we provide access to our voice dictation technology
                and related services (&quot;Services&quot;). By purchasing or subscribing
                to any of our Services, you agree to the terms of this Cancellation Policy.
              </p>

            <h2>CANCELLATION AND REFUNDS</h2>
            <p>
              Due to the nature of our Services, which provide immediate access to
              digital content and functionality upon purchase or subscription,
              <strong> all purchases and subscriptions are final and non-refundable.</strong>
            </p>
            <p>
              Once a Service is purchased or a subscription is activated, you will
              have immediate access to the Service, and therefore, we do not offer
              refunds or credits for any reason, including but not limited to:
            </p>
            <ul>
              <li>Your decision to stop using the Services.</li>
              <li>Your dissatisfaction with the Services.</li>
              <li>Your failure to use the Services.</li>
              <li>Technical issues on your end (unless caused by a failure in our Services).</li>
            </ul>

            <h2>EXCEPTIONS</h2>
            <p>
              We may, in our sole discretion, offer a refund or credit in
              exceptional circumstances, such as in the case of a billing error
              directly caused by voicetyping.xyz. Any such exceptions will be
              handled on a case-by-case basis.
            </p>

            <h2>CHARGEBACKS</h2>
            <p>
              By purchasing our Services, you agree to waive any right to
              initiate chargebacks or reversed transactions with your bank or
              payment provider. Any attempt to initiate a chargeback contrary
              to this policy may result in the suspension or termination of
              your access to the Services.
            </p>

            <h2>CHANGES TO THIS POLICY</h2>
            <p>
              We reserve the right to update or modify this Cancellation Policy
              at any time without prior notice. The effective date at the top
              of the policy will indicate when the latest changes were made.
              Your continued use of the Services after any changes to this
              Cancellation Policy constitutes your acceptance of the revised
              terms.
            </p>

            <h2>CONTACTING US</h2>
            <p>
              If you have any questions about this Cancellation Policy, please
              contact AryaStack Technologies at: fxnoob71@gmail.com or via https://aryastack.com.
            </p>
          </div>
        </div>
      </div>
      </Container>
      <Footer />
    </Page>
  );
}
